import {VacatureService} from '../../services/vacature.service';
import {Component, inject} from '@angular/core';
import {LoadingVacatureInfoComponent} from '../loading-vacature-info/loading-vacature-info.component';
import {FormsModule} from '@angular/forms';
import {VacatureInfoComponent} from '../vacature-info/vacature-info.component';
import {AsyncPipe} from '@angular/common';

@Component({
  selector: 'mvw-mijn-vacatures-page',
  imports: [
    LoadingVacatureInfoComponent,
    FormsModule,
    VacatureInfoComponent,
    AsyncPipe
  ],
  templateUrl: './mijn-vacatures-page.component.html'
})
export class MijnVacaturesPageComponent {

  private readonly vacatureService = inject(VacatureService);

  trefwoordInput: string | undefined;

  vacatureInfo$ = this.vacatureService.getVacatureInfo$();
  serverError$ = this.vacatureService.getServerError$();

  getTrefwoord(): string {
    const trefwoord = (this.trefwoordInput ?? '').trim();
    const urlZonderTrefwoord = '/vac/werkgevers/mijnjobs?showZoekDiv=true';
    const urlMetTrefwoord = '/vac/werkgevers/mijnjobs?showZoekDiv=true&trefwoord=';
    return trefwoord.length === 0 ? urlZonderTrefwoord : urlMetTrefwoord + encodeURIComponent(trefwoord);
  }

  triggerTrefwoordLink(): void {
    const link = document.getElementById('trefwoordLink');
    link?.click();
  }

}
